import { Button, Dialog, EmptyState, Icon, Icons, Intent, List, ListItem, Size, Spinner } from "construct-ui";
import { codeMasterType } from "../../config/constants";
import codeMasterModel from "../../models/common/code-master.model";
import userSearchModal from "../../models/common/user-search.modal";
import loginModel from "../../models/login.model";
import userModel from "../../models/user/user.model";
import ViewBase from "../../views/view-base.view";
import MultiSelectComponent from "../multi-select/multi-select.component";
import QueryListComponent from "../query-list/query-list.component";
import SingleSelectComponent from "../single-select/single-select.component";
import SelectSiteGroupComponent from "../site/select-site-group.component";
import SelectSiteComponent from "../site/select-site.component";
import UDFComponent from "../udf/udf.component";
import { exportUserExcelTemplate} from '../../models/file.model'

export default function SelectUserComponent() {
  ViewBase.call(this);

  const TITLE_SEPARATOR = ', ';

  const USER_ID_KEY = 'userID';
  const USERNAME_KEY = 'userName';
  const USER_GROUP_OPTIONS = [
    { id: 0, label: { code: "LT00000322", defaultText: "All Users" }, isDefault: true },
    { id: 1, label: { code: "LT00000323", defaultText: "My Team" }, isDefault: false },
    { id: 2, label: { code: "LT00000542", defaultText: "Upload Users" }, isDefault: false }
  ];

  // Common variables
  let required = false;
  let multiple = true;
  let isOpenUserSelect = false;

  // All users tab variables
  let isSearchingAllUsers = false;
  let isAllUsersPageEnd = false;
  let allUsersSearchTotal = 0;
  let userList;

  // My team tab variables
  let hideMyTeam = false;
  let isSearchingMyTeam = false;
  let myTeamUserList;

  // Upload tab variables
  let hideUploadUsers = false;
  let isUploaded = false;
  let isUploadingExcel = false;
  let failedUploadedUserIdList;

  let userRoleOptionList;
  let userStatusOptionList;
  let udfList;
  let udfValueList;
  let selectedUserList = [];
  let selectedUserRoleList = [];
  let selectedUserStatusList = [];
  let selectedSiteList = [];
  let selectedSiteGroupList = [];
  let selectedUdfList = [];
  let defaultUserStatus = [];
  let defaultUserStatusCode = [];
  let filter = { userID: '', userName: '', userRoleCode: '', siteGroupID: '', siteCode: '', userUDF: [], pageSize: 100, pageIndex: 1 }
  let uiListHeight = '300px'
  let validationMessage = {};

  let getRoleFilter = (e) => { return []; };
  let onSelect = (e) => { };

  const buildSelectedUsers = (selectedUsers) => {
    if (selectedUsers == null || selectedUsers.length === 0)
      return [];

    if (typeof selectedUsers[0] === 'object') {
      return selectedUsers.map(u => {

        // As long as user object contains userId and userName, accept it as an valid object
        if (u.hasOwnProperty(USER_ID_KEY) && u.hasOwnProperty(USERNAME_KEY)) {
          return u;
        }
      });
    } else {
      // Currently this component does not accept ID only.
      // It'll be treated as incorrect data and return an empty list.
      return [];
    }
  };

  let getUserRoleList = () => {
    userRoleOptionList = [];
    let roleFilter = getRoleFilter();
    userSearchModal.getUserRoleList(
      (result) => {
        if (result) {
          result.forEach(e => {
            userRoleOptionList.push({ ...e });
          });
          if (roleFilter.length > 0) {
            userRoleOptionList = userRoleOptionList.filter(r => roleFilter.some(l => l.code == r.code));
            selectedUserRoleList = [...userRoleOptionList];
          }
        }
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  let getUserStatusList = () => {
    userStatusOptionList = [];
    defaultUserStatus = [];
    selectedUserStatusList = [];
    codeMasterModel.getByCategory(
      (result) => {
        result.forEach(e => {
          userStatusOptionList.push({ ...e });
          if (defaultUserStatusCode.includes(e.code)) {
            defaultUserStatus.push({ ...e });
            selectedUserStatusList.push({ ...e });
          }
        });
      },
      (error) => {
        this.handleError(error);
      },
      { category: codeMasterType.userStatus, countryCode: loginModel.credentials.country }
    );
  }

  let getUDFList = () => {
    udfList = [];
    udfValueList = [];
    userSearchModal.getUDFList(
      (result) => {
        if (result?.udfAttributes) {
          result.udfAttributes.map(udf => udfList.push({ ...udf }));
        }
        if (result?.udfValues) {
          result.udfValues.map(val => udfValueList.push({ ...val }));
        }
      },
      (error) => {
        this.handleError(error);
      },
      loginModel.credentials.country
    )
  }

  let addUdfElement = (udf) => {
    selectedUdfList.push({ ...udf });
  }

  let removeUdfElement = (index) => {
    selectedUdfList.splice(index, 1);
  }

  let loadSearchFilterData = () => {
    getUserRoleList();
    getUserStatusList();
    getUDFList();
  }

  let searchUsers = (refreshUserList = true) => {
    isSearchingAllUsers = true;

    filter.userRoleCode = selectedUserRoleList.map(o => o.code).join('^');
    filter.statusCode = selectedUserStatusList.map(o => o.code).join('^');
    filter.siteGroupID = selectedSiteGroupList.map(o => o.code).join('^');
    filter.siteCode = selectedSiteList.map(o => o.code).join('^');
    filter.userUDF = [];
    selectedUdfList.map(udf => {
      const selectedUdf = {};
      if (udf.value && udf.value !== '') {
        if (udf.type === 'Dropdown') {
          if (udf.value.length > 0) {
            selectedUdf.udfId = udf.attributeId;
            selectedUdf.udfValue = udf.value;
            filter.userUDF.push(selectedUdf);
          }
        } else {
          selectedUdf.udfId = udf.attributeId;
          selectedUdf.udfValue = [udf.value];
          filter.userUDF.push(selectedUdf);
        }
      }
    });

    if (refreshUserList) {
      userList = [];
      filter.pageIndex = 1;
    }

    userModel.getUserList(
      (result) => {
        if (result.data && result.data.length > 0) {
          result.data.forEach(e => {
            userList.push({ ...e });
          });

          isAllUsersPageEnd = result.pageIndex * result.pageSize >= result.total;
        }
        allUsersSearchTotal = result.total;
        isSearchingAllUsers = false;
      },
      (error) => {
        isSearchingAllUsers = false;
        this.handleError(error);
      },
      filter
    );
  }

  let clearSearchFilter = () => {
    userList = [];
    selectedUserRoleList = [];
    selectedUserStatusList.splice(0, Infinity, ...defaultUserStatus);
    selectedSiteGroupList = [];
    selectedSiteList = [];
    selectedUdfList = [];
    filter.userID = '';
    filter.userName = '';
    filter.userRoleCode = '';
    filter.siteGroupID = '';
    filter.siteCode = '';
    filter.userUDF = [];
    filter.pageIndex = 1;
    allUsersSearchTotal = 0;
  }

  let clearUserSelection = () => {
    selectedUserList.splice(0, selectedUserList.length);
    onSelect(selectedUserList);
  }

  let getMyTeamUsers = () => {
    isSearchingMyTeam = true;

    myTeamUserList = [];
    userModel.getUserListBySupervisor().then(data => {
      if (data && data.length > 0) {
        data.forEach(e => {
          myTeamUserList.push({ ...e });
        });
      }
    }).catch(error => {
      this.handleError(error);
    }).then(() => {
      isSearchingMyTeam = false;
    })
  }

  const downloadUserListTemplate = () => {
    const fileName = "User List Template.xlsx";
    const exportConfig = {
      storedProcedureCode: "20",
      params: [{ code: "55", value: "ALTMP0001" }],
      excelSheetNames: ["User List"],
    };
    exportUserExcelTemplate(exportConfig, fileName)
      .catch((error) => {
        this.handleError(error);
      })
  }

  let validateFileInput = () => {
    let fileInput = document.getElementById('select-user__file-upload');
    var filePath = fileInput.value;

    // Allowed file type
    var allowedExtensions = /(\.xlsx)$/i;
    // /(\.doc|\.docx|\.odt|\.pdf|\.tex|\.txt|\.rtf|\.wps|\.wks|\.wpd)$/i;

    if (!allowedExtensions.exec(filePath)) {
      fileInput.setCustomValidity(this.getText("LT00000549", "Please select a .xlsx file to upload"));
    } else {
      fileInput.setCustomValidity("");
    }
  }

  let uploadExcel = (e) => {
    e.preventDefault();

    // Validate upload form
    validateFileInput();
    e.target.classList.add('was-validated');
    if (!e.target.checkValidity()) {
      e.stopPropagation();
      return;
    }

    isUploadingExcel = true;
    failedUploadedUserIdList = [];

    let fileInput = document.getElementById('select-user__file-upload');
    var files = fileInput.files;
    var uploadFormData = new FormData();
    for (var i = 0; i < files.length; i++) {
      uploadFormData.append("file", files[i]);
    }

    userModel.getUserListByExcel(uploadFormData).then(data => {
      if (data.data) {
        data.data.map(user => {
          if (selectedUserList.findIndex(s => s.userID === user.userID) < 0) {
            selectedUserList.push(user);
          }
        });
        selectedUserList.sort(sortByName);
        onSelect(selectedUserList);
      }

      if (data.failedUpload) {
        data.failedUpload.map(userId => {
          failedUploadedUserIdList.push(userId);
        });
      }

      isUploaded = true;
    }).catch(error => {
      this.handleError(error);
    }).then(() => {
      isUploadingExcel = false;
    })
  }

  let deselectUser = (userId) => {
    let idx = selectedUserList.findIndex(s => s.userID === userId);
    if (idx > -1) {
      selectedUserList.splice(idx, 1);
      onSelect(selectedUserList);
    }
  }

  // case-insensitive
  let sortByName = (a, b) => {
    const valueA = a.userName.toUpperCase();
    const valueB = b.userName.toUpperCase();
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  }

  let resetUploadStatus = () => {
    isUploaded = false;
    failedUploadedUserIdList = [];
  }

  let renderLabel = () => {
    if (selectedUserList && selectedUserList.length > 0) {
      if (selectedUserList.length === 1) {
        return selectedUserList[0].userName;
      } else {
        return selectedUserList.length + ' ' + this.getText("LT00000308", "item(s) selected");
      }
    }

    return '';
  }

  const renderTitle = () => {
    if (selectedUserList && selectedUserList.length > 0) {
      return selectedUserList.map(user => user.userName).join(TITLE_SEPARATOR);
    }

    return '';
  }

  let SelectUserDialogContent = {
    oninit: (vnode) => {
      clearSearchFilter();
      loadSearchFilterData();
      getMyTeamUsers();
      resetUploadStatus();
    },
    view: (vnode) => {
      return m('.container',
        m('nav',
          m('.nav.nav-tabs.flex-row.justify-content-start#nav-tab[role="tablist"]',
            USER_GROUP_OPTIONS.map((ug) =>
              ((ug.id === 0) ||
                (ug.id === 1 && !hideMyTeam) ||
                (ug.id === 2 && !hideUploadUsers && multiple) ||
                ug.id > 2) &&
              m('button.nav-item.nav-link[data-bs-toggle="tab"][type="button"][role="tab"]',
                {
                  id: `nav-tab-${ug.id}`,
                  'data-bs-target': `#nav-content-${ug.id}`,
                  'aria-controls': `nav-content-${ug.id}`,
                  class: ug.isDefault ? 'active' : '',
                  'aria-selected': ug.isDefault ? 'true' : 'false',
                },
                this.getText(ug.label.code, ug.label.defaultText)),
            ),
          )
        ),
        m('.tab-content',
          searchUsersTab(),
          !hideMyTeam && myTeamTab(),
          !hideUploadUsers && multiple && uploadTeamTab()
        )
      )
    }
  };

  const searchUsersTab = () => {
    // Tab 0 - All Users
    return m('.tab-pane.fade#nav-content-0[role="tabpanel"][aria-labelledby="nav-tab-0"]', {
      class: 'show active'
    },
      // Search section
      m('.card.mb-3',
        m('.card-body',
          m('.row.g-4.align-items-end',
            m('.col-md-4',
              m('label.form-label', this.getText("LT00000049", "User ID")),
              m('input.form-control[type=text]', {
                placeholder: this.getText("LT00000049", "User ID"),
                onchange: e => filter.userID = e.target.value,
                value: filter.userID,
              })
            ),
            m('.col-md-4',
              m('label.form-label', this.getText("LT00000050", "User Name")),
              m('input.form-control[type=text]', {
                placeholder: this.getText("LT00000050", "User Name"),
                onchange: e => filter.userName = e.target.value,
                value: filter.userName,
              })
            ),
            m('.col-md-4',
              m('label.form-label', this.getText("LT00000060", "User Role")),
              m(MultiSelectComponent, {
                items: userRoleOptionList,
                selectedItems: selectedUserRoleList,
                onSelect: (s) => {
                  selectedUserRoleList = s;
                  let roleFilter = getRoleFilter();
                  if (roleFilter.length > 0 && selectedUserRoleList.length == 0) {
                    selectedUserRoleList = [...roleFilter];
                  }
                }
              }),
            ),
            m('.col-md-4',
              m('label.form-label', this.getText("LT00000221", "User Status")),
              m(MultiSelectComponent, {
                items: userStatusOptionList,
                selectedItems: selectedUserStatusList,
                onSelect: (s) => {
                  selectedUserStatusList = s;
                }
              }),
            ),
            m('.col-md-4',
              m('label.form-label', this.getText("LT00000072", "Site Group")),
              m(SelectSiteGroupComponent, {
                selectedItems: selectedSiteGroupList,
                onChange: (s) => {
                  selectedSiteGroupList = s;
                }
              }),
            ),
            m('.col-md-4',
              m('label.form-label', this.getText("LT00000071", "Site")),
              m(SelectSiteComponent, {
                selectedItemList: selectedSiteList,
                onChange: (s) => {
                  selectedSiteList = s;
                }
              }),
            ),
            selectedUdfList && selectedUdfList.length > 0 &&
            selectedUdfList.map((udf, index) =>
              m('.col-md-4',
                m('.d-flex.justify-content-between',
                  m('label.form-label', udf.name),
                  m(Icon, {
                    intent: Intent.NEGATIVE,
                    name: Icons.X,
                    onclick: () => removeUdfElement(index),
                    size: 'lg',
                  }),
                ),
                m(UDFComponent, {
                  type: udf.type,
                  items: udfValueList.filter(v => v.attributeId === udf.attributeId),
                  value: udf.value,
                  onChange: e => {
                    if (udf.type === 'Dropdown') {
                      udf.value = e;
                    } else {
                      udf.value = e.target.value;
                    }
                  }
                }),
              ),
            ),
            m('.col-md-4',
              m(SingleSelectComponent, {
                items: udfList.filter(e => !selectedUdfList.map(x => x.attributeId).includes(e.attributeId)),
                itemKey: 'attributeId',
                itemValue: 'name',
                onSelect: addUdfElement,
                isButton: true,
                allowEmpty: false,
                buttonAttrs: {
                  label: this.getText("LT00000324", "Add User Defined Field(s)"),
                  fluid: false,
                  intent: Intent.POSITIVE,
                  outlined: false,
                },
              }),
            ),
            m('.col-12',
              m('.d-flex.justify-content-end.gap-2',
                m(Button, {
                  label: this.getText("LT00000001", "Search"),
                  intent: Intent.PRIMARY,
                  loading: isSearchingAllUsers,
                  onclick: searchUsers,
                }),
                m(Button, {
                  label: this.getText("LT00000031", "Clear"),
                  intent: Intent.PRIMARY,
                  outlined: true,
                  onclick: () => {
                    clearSearchFilter();
                  }
                }),
              ),
            ),
          ),
        )
      ),
      // Result section & selected items section
      multiple
        ? m('.row.g-4',
          m('.col-md-6',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: { height: uiListHeight } },
                  (userList && userList.length > 0) || (selectedUserList && selectedUserList.length > 0) || isSearchingAllUsers
                    ? m(QueryListComponent, {
                      items: userList.map((user) => { return { userID: user.userID, userName: user.userName || user.userID } }),
                      itemKey: 'userID',
                      itemValue: 'userName',
                      multiple: multiple,
                      style: { height: uiListHeight },
                      selectedItems: selectedUserList,
                      onSelect: onSelect,
                      onInfiniteScroll: () => {
                        if (!isSearchingAllUsers && !isAllUsersPageEnd) {
                          filter.pageIndex++;
                          searchUsers(false);
                          m.redraw();
                        }
                      }
                    })
                    : m(EmptyState, {
                      icon: Icons.SEARCH,
                      content: this.getText("LT00000317", "No results found"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    })
                ),
                isSearchingAllUsers && m(Spinner, { fill: true, background: true, active: true })
              )
            ),
            m('.d-flex.justify-content-end',
              m('span.mt-1',
                { style: 'font-size: 0.875em;' },
                `${userList && userList.length > 0 ? userList.length : '0'} / ${allUsersSearchTotal} ${this.getText("LT00000364", "record(s)")}`
              )
            )
          ),
          m('.col-md-6',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: `min-height: ${uiListHeight}` },
                  selectedUserList && selectedUserList.length > 0 ?
                    m(List, {
                      interactive: true,
                      style: {
                        height: uiListHeight
                      }
                    },
                      selectedUserList.map(item => m(ListItem, {
                        label: item.userName,
                        contentRight: m(Icon, {
                          name: Icons.X,
                          intent: Intent.NEGATIVE,
                          onclick: e => {
                            deselectUser(item.userID);
                          }
                        })
                      })))
                    :
                    m(EmptyState, {
                      icon: Icons.USER_X,
                      content: this.getText("LT00000325", "No users selected"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    }),
                )
              )
            ),
            m('.d-flex.justify-content-end.align-items-center.gap-3',
              m('a.btn.btn-link.p-0.mt-1', { onclick: clearUserSelection }, this.getText("LT00000545", "Clear selections")),
              m('span.mt-1',
                { style: 'font-size: 0.875em;' },
                ((selectedUserList ? selectedUserList.length : '0') + ' ' + this.getText("LT00000364", "record(s)"))
              )
            )
          )
        )
        : m('.row',
          m('.col',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: { height: uiListHeight } },
                  (userList && userList.length > 0) || (selectedUserList && selectedUserList.length > 0) || isSearchingAllUsers
                    ? m(QueryListComponent, {
                      items: userList.map((user) => { return { userID: user.userID, userName: user.userName || user.userID } }),
                      itemKey: 'userID',
                      itemValue: 'userName',
                      multiple: multiple,
                      style: { height: uiListHeight },
                      selectedItem: selectedUserList[0],
                      onSelect: (user) => { onSelect(user ? [user] : []); },
                      onInfiniteScroll: () => {
                        if (!isSearchingAllUsers && !isAllUsersPageEnd) {
                          filter.pageIndex++;
                          searchUsers(false);
                          m.redraw();
                        }
                      }
                    })
                    : m(EmptyState, {
                      icon: Icons.SEARCH,
                      content: this.getText("LT00000317", "No results found"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    })
                ),
                isSearchingAllUsers && m(Spinner, { fill: true, background: true, active: true })
              )
            ),
            m('.d-flex.justify-content-end',
              m('span.mt-1',
                { style: 'font-size: 0.875em;' },
                `${userList && userList.length > 0 ? userList.length : '0'} / ${allUsersSearchTotal} ${this.getText("LT00000364", "record(s)")}`
              )
            )
          )
        )
    );
  };

  const myTeamTab = () => {
    return m('.tab-pane.fade#nav-content-1[role="tabpanel"][aria-labelledby="nav-tab-1"]',
      multiple
        ? m('.row.g-4',
          m('.col-md-6',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: { height: uiListHeight } },
                  (myTeamUserList && myTeamUserList.length > 0) || (selectedUserList && selectedUserList.length > 0) || isSearchingMyTeam
                    ? m(QueryListComponent, {
                      items: myTeamUserList.map((user) => { return { userID: user.userID, userName: user.userName || user.userID } }),
                      itemKey: 'userID',
                      itemValue: 'userName',
                      multiple: multiple,
                      style: { height: uiListHeight },
                      selectedItems: selectedUserList,
                      onSelect: onSelect
                    })
                    : m(EmptyState, {
                      icon: Icons.USER_X,
                      content: this.getText("LT00000317", "No results found"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    })
                ),
                isSearchingMyTeam && m(Spinner, { fill: true, background: true, active: true })
              )
            ),
            m('.d-flex.justify-content-end',
              m('span.mt-1',
                { style: 'font-size: 0.875em;' },
                ((myTeamUserList && myTeamUserList.length > 0) ? myTeamUserList.length : '0') + ' ' + this.getText("LT00000364", "record(s)")
              )
            )
          ),
          m('.col-md-6',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: `min-height: ${uiListHeight}` },
                  selectedUserList && selectedUserList.length > 0
                    ? m(List, {
                      interactive: true,
                      style: {
                        height: uiListHeight
                      }
                    },
                      selectedUserList.map(item => m(ListItem, {
                        label: item.userName,
                        contentRight: m(Icon, {
                          name: Icons.X,
                          intent: Intent.NEGATIVE,
                          onclick: e => {
                            deselectUser(item.userID);
                          }
                        })
                      }))
                    )
                    : m(EmptyState, {
                      icon: Icons.USER_X,
                      content: this.getText("LT00000325", "No users selected"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    }),
                )
              )
            ),
            m('.d-flex.justify-content-end.align-items-center.gap-3',
              m('a.btn.btn-link.p-0.mt-1', { onclick: clearUserSelection }, this.getText("LT00000545", "Clear selections")),
              m('span.mt-1',
                { style: 'font-size: 0.875em;' },
                ((selectedUserList ? selectedUserList.length : '0') + ' ' + this.getText("LT00000364", "record(s)"))
              )
            )
          )
        )
        : m('.row',
          m('.col',
            m('.card',
              m('.card-body',
                m('.position-relative', { style: { height: uiListHeight } },
                  (myTeamUserList && myTeamUserList.length > 0) || (selectedUserList && selectedUserList.length > 0) || isSearchingMyTeam
                    ? m(QueryListComponent, {
                      items: myTeamUserList.map((user) => { return { userID: user.userID, userName: user.userName || user.userID } }),
                      itemKey: 'userID',
                      itemValue: 'userName',
                      multiple: multiple,
                      style: { height: uiListHeight },
                      selectedItem: selectedUserList[0],
                      onSelect: (user) => { onSelect(user ? [user] : []) }
                    })
                    : m(EmptyState, {
                      icon: Icons.USER_X,
                      content: this.getText("LT00000317", "No results found"),
                      fill: true,
                      style: 'color: #B5B5B5',
                    })
                ),
                isSearchingMyTeam && m(Spinner, { fill: true, background: true, active: true })
              )
            ),
            m('.d-flex.justify-content-end',
              m('span.mt-1',
                { style: 'font-size: 0.875em;' },
                ((myTeamUserList && myTeamUserList.length > 0) ? myTeamUserList.length : '0') + ' ' + this.getText("LT00000364", "record(s)")
              )
            )
          )
        )
    );
  };

  const uploadTeamTab = () => {
    return m('.tab-pane.fade#nav-content-2[role="tabpanel"][aria-labelledby="nav-tab-2"]',
      // Download template form
      m('.card.mb-3',
        m('.card-body',
          m('.row.g-4.align-items-end',
            m('.col-md-7',
              m('label.form-label.d-block', '1. ', this.getText("LT00000218", "Download Template")),
              m(Button, {
                class: 'ms-3',
                iconLeft: Icons.DOWNLOAD,
                intent: Intent.PRIMARY,
                label: this.getText("LT00000220", "Excel Template"),
                size: Size.SM,
                onclick: downloadUserListTemplate
              })
            ),
            m('.col-md-7',
              m('label.form-label', '2. ', this.getText("LT00000197", "Excel Upload")),
              m('form.d-flex.gap-2.needs-validation[novalidate]', { onsubmit: uploadExcel },
                m('.flex-grow-1.ps-3',
                  m('input#select-user__file-upload.form-control[type=file][required]', {
                    onchange: e => {
                      if (!e.target.files || e.target.files.length === 0) {
                        // Reset previous upload status
                        resetUploadStatus();
                      }
                    },
                    oninvalid: e => {
                      validationMessage.fileUpload = e.target.validationMessage;
                    }
                  }),
                  m('.invalid-tooltip', validationMessage.fileUpload),
                ),
                m('.flex-shrink-0',
                  m('button.btn.btn-primary[type=submit]', {
                    disabled: isUploadingExcel
                  },
                    isUploadingExcel
                      ? [
                        m('span.spinner-border.spinner-border-sm.me-2[role="status"][aria-hidden="true"]'),
                        this.getText("LT00000543", "Uploading")
                      ]
                      : this.getText("LT00000290", "Upload")
                  ),
                ),
              ),
            ),
          ),
        )
      ),
      // Upload result section & selected items section
      m('.row.g-4',
        m('.col-md-6',
          m('.card',
            m('.card-body',
              m('.position-relative', { style: `min-height: ${uiListHeight}` },
                m('.flex.flex-column', {
                  style: {
                    'max-height': uiListHeight,
                    'overflow': 'auto',
                  }
                },
                  failedUploadedUserIdList && failedUploadedUserIdList.length > 0
                    ? [
                      m('.position-sticky.top-0.bg-white.fw-bold.text-danger', this.getText("LT00000544", "Invalid User ID(s)")),
                      m('ol',
                        failedUploadedUserIdList.map(uId => m('li.ps-1', uId))
                      )
                    ]
                    : isUploaded
                      ? m(EmptyState, {
                        icon: Icons.USER_CHECK,
                        content: this.getText("LT00000546", "Uploaded users have been selected"),
                        fill: true,
                        style: 'color: #B5B5B5',
                      })
                      : m(EmptyState, {
                        icon: Icons.UPLOAD,
                        content: this.getText("LT00000547", "Please upload user list"),
                        fill: true,
                        style: 'color: #B5B5B5',
                      })
                ),
              )
            )
          ),
        ),
        m('.col-md-6',
          m('.card',
            m('.card-body',
              m('.position-relative', { style: `min-height: ${uiListHeight}` },
                selectedUserList && selectedUserList.length > 0
                  ? m(List, {
                    interactive: true,
                    style: {
                      height: uiListHeight
                    }
                  },
                    selectedUserList.map(item => m(ListItem, {
                      label: item.userName,
                      contentRight: m(Icon, {
                        name: Icons.X,
                        intent: Intent.NEGATIVE,
                        onclick: e => {
                          deselectUser(item.userID);
                        }
                      })
                    }))
                  )
                  : m(EmptyState, {
                    icon: Icons.USER_X,
                    content: this.getText("LT00000325", "No users selected"),
                    fill: true,
                    style: 'color: #B5B5B5',
                  }),
              )
            )
          ),
          m('.d-flex.justify-content-end.align-items-center.gap-3',
            m('a.btn.btn-link.p-0.mt-1', { onclick: clearUserSelection }, this.getText("LT00000545", "Clear selections")),
            m('span.mt-1',
              { style: 'font-size: 0.875em;' },
              ((selectedUserList ? selectedUserList.length : '0') + ' ' + this.getText("LT00000364", "record(s)"))
            )
          )
        )
      )
    );
  }

  const readOnly = (event) => {
    event.preventDefault();
    event.stopImmediatePropogation();
  }

  return {
    oninit: (vnode) => {
      multiple = vnode.attrs.multiple ?? multiple;

      if (vnode.attrs.onSelect) {
        onSelect = vnode.attrs.onSelect;
      }

      if (vnode.attrs.getRoleFilter) {
        getRoleFilter = vnode.attrs.getRoleFilter;
      }

      if (vnode.attrs.selectedUserList) {
        selectedUserList = vnode.attrs.selectedUserList;
      }

      if (vnode.attrs.required) {
        required = vnode.attrs.required;
      }

      if (vnode.attrs.default?.userStatusCode) {
        defaultUserStatusCode = [vnode.attrs.default.userStatusCode];
      }

      if (typeof vnode.attrs.hideMyTeam === 'boolean') {
        hideMyTeam = vnode.attrs.hideMyTeam;
      }

      if (typeof vnode.attrs.hideUploadUsers === 'boolean') {
        hideUploadUsers = vnode.attrs.hideUploadUsers;
      }
    },
    view: (vnode) => {
      selectedUserList = buildSelectedUsers(vnode.attrs.selectedUserList);

      return [
        m('.select-input-component.d-flex.justify-content-between.align-items-center.form-control.form-control-bg', {
          class: vnode.attrs.disabled ? 'disabled ' : '',
          onclick: () => {
            if (!vnode.attrs.disabled) {
              isOpenUserSelect = !isOpenUserSelect;
            }
          }
        },
          m('input.flex-fill.text-start.ps-0', {
            autocomplete: 'off',
            id: vnode.attrs.id,
            disabled: vnode.attrs.disabled,
            required,
            type: 'text',
            placeholder: vnode.attrs.placeholder || this.getText("LT00000201", "Please select"),
            oninput: readOnly,
            style: {
              width: 'inherit',
              'overflow-x': 'hidden',
              'text-overflow': 'ellipsis',
              border: 'none',
              background: 'transparent'
            },
            value: renderLabel(),
            title: renderTitle()
          }),
          m(Icon, { name: Icons.USERS, intent: Intent.PRIMARY })
        ),
        isOpenUserSelect &&
        m(Dialog, {
          class: 'cui-dialog-xl',
          closeOnOutsideClick: false,
          isOpen: isOpenUserSelect,
          onClose: () => isOpenUserSelect = false,
          title: this.getText("LT00000061", "User Selection"),
          content: m(SelectUserDialogContent, {
            onClose: () => { isOpenUserSelect = false },
          }),
          footer: m('.hstack.justify-content-end',
            m('button.btn.btn-white', { onclick: () => { isOpenUserSelect = false } }, this.getText('LT00000021', 'Close'))
          )
        }),
        this.getBaseViews()
      ]
    }
  }
}
